import {
  getClientStateData,
  setClientStateData,
} from 'app/services/api/client-state.service'
import { getBookId } from 'app/services/reader/reader-utils.service'
import promiseHandler from 'app/utils/promise-handler'

const getAnnotationKey = () => `annotations-${getBookId()}`

const getAllAnnotations = async () => {
  const [error, data] = await promiseHandler(
    getClientStateData(getAnnotationKey())
  )
  return !!error || !data ? {} : data
}

const saveAnnotation = async (annotations: object) => {
  await setClientStateData(getAnnotationKey(), annotations)
}

const removeAnnotation = async (annotations: object) => {
  await setClientStateData(getAnnotationKey(), annotations)
}

export default {
  getAllAnnotations,
  saveAnnotation,
  removeAnnotation,
}
